import { jsx as _jsx } from "react/jsx-runtime";
export const FormatterWrapper = ({ children }) => {
    return _jsx("div", { className: 'min-w-6 h-6 flex items-center justify-center', children: children });
};
